import { Box } from 'app/components/design-system-components'
import { AttachFileRounded } from 'app/components/design-system-components/icons/editor'
import { ToolTip } from 'app/components/design-system-components/Tooltip'
import theme from 'app/match/applicationReportPDF/assets/theme'

const NO_DOCUMENTS_UPLOADED =
  'No documents uploaded or documents have been auto-deleted. Please upload.'
const DOCUMENTS_UPLOADED = 'Documents have been uploaded.'

const AttachmentWithTooltip = ({
  color = '',
  content = '',
  tooltipID = '',
}) => {
  return (
    <Box mr={3}>
      <ToolTip
        toolTipID={tooltipID}
        icon={
          <AttachFileRounded
            color={color}
            width={theme.width[6] + 'px'}
            height={theme.height[6] + 'px'}
          />
        }
        content={<>{content}</>}
      />
    </Box>
  )
}

function RentalRepIconChecker({
  attachmentSupportedSection = false,
  isCompleted = false,
  tooltipID = '',
}) {
  if (!attachmentSupportedSection) {
    return null
  }
  switch (isCompleted) {
    case true:
      return (
        <AttachmentWithTooltip
          color={theme.colors.success600}
          content={DOCUMENTS_UPLOADED}
          tooltipID={tooltipID}
        />
      )
    case false:
      return (
        <AttachmentWithTooltip
          color={theme.colors.gray400}
          content={NO_DOCUMENTS_UPLOADED}
          tooltipID={tooltipID}
        />
      )
    default:
      return null
  }
}

export default RentalRepIconChecker
